export const generateRandomKey = () => {
  return Math.random().toString(36).substr(2, 9); // Generate a random string of length 9
};
